import React, { Component } from 'react';
import { toast } from 'react-toastify';

import api from '../../api';
import Grid from '../../components/Grid';
import { getMessageFromRequest } from '../../utils/errors';

import routesColumnsDef from './routesColumnsDef';


const INITIAL_STATE = {
  shadowRoutes: null,
}

class Routes extends Component {

  constructor() {
    super();

    // creates function once per component instance
    this.onRoutesGridRowsUpdated = this.onRoutesGridRowsUpdated.bind(this);
  }

  state = {
    ...INITIAL_STATE,
  }

  // Request

  updateRoute = async (data) => {
    try {
      // const request = await api.comercial.route.updateRoute(data);
      await api.comercial.route.updateRoute(data);
      return true;
    } catch (err) {
      toast.error(`Erro ao editar rota: ${getMessageFromRequest(err)}`);
      return false;
    }
  }

  // Grid

  async onRoutesGridRowsUpdated({ fromRow, toRow, updated, fromRowData }) {

    if(Object.keys(updated)[0] === "route") { 
      if(updated.route === "") {
        updated.route = 0
      } else {
        updated.route = parseFloat(updated.route)
      }
    }

    // Atualiza no back a alteração
    if(!await this.updateRoute({ ...fromRowData, ...updated })) { return };

    const routesData = this.props.routes.slice();
    for (let i = fromRow; i <= toRow; i++) {
      routesData[i] = { ...routesData[i], ...updated };
    };

    this.props.updateGridState(routesData);

  };

  render() {
    const {
      // Routes
      routes,
    } = this.props;

    return (
      <Grid
        reflectShadowRows={shadowRoutes => this.setState({ shadowRoutes })}
        data={routes}
        minHeight={400}
        rawColumnsDef={routesColumnsDef}
        columns={routesColumnsDef}
        rowHeight={20}
        // headerRowHeight={20}
        // enableSummary
        highlightActiveRow
        onGridRowsUpdated={this.onRoutesGridRowsUpdated}
      />
    );
  }
}

export default Routes;
